module.exports = __webpack_public_path__ + "images/8bfe8a1be06e42ec7428e8a7dc25a535.webp";